import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const LeaveWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LeaveWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"member"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"MemberOrEmail"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"removeMemberFromWorkspace"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orgId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"workspaceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"traceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"traceId"}}},{"kind":"Argument","name":{"kind":"Name","value":"user"},"value":{"kind":"Variable","name":{"kind":"Name","value":"member"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"LeaveWorkspace","document":LeaveWorkspaceDocument}} as const;
export type LeaveWorkspaceMutationVariables = Types.Exact<{
  member: Types.MemberOrEmail;
  traceId: Types.Scalars['String']['input'];
  workspaceId: Types.Scalars['ID']['input'];
}>;


export type LeaveWorkspaceMutation = (
  { __typename: 'Mutation' }
  & { removeMemberFromWorkspace?: Types.Maybe<(
    { __typename: 'RemoveMembersFromWorkspace_Response' }
    & Pick<Types.RemoveMembersFromWorkspace_Response, 'success'>
  )> }
);

export type LeaveWorkspaceMutationFn = Apollo.MutationFunction<
  LeaveWorkspaceMutation,
  LeaveWorkspaceMutationVariables
>;

/**
 * __useLeaveWorkspaceMutation__
 *
 * To run a mutation, you first call `useLeaveWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLeaveWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [leaveWorkspaceMutation, { data, loading, error }] = useLeaveWorkspaceMutation({
 *   variables: {
 *      member: // value for 'member'
 *      traceId: // value for 'traceId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useLeaveWorkspaceMutation(
  baseOptions?: Apollo.MutationHookOptions<
    LeaveWorkspaceMutation,
    LeaveWorkspaceMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    LeaveWorkspaceMutation,
    LeaveWorkspaceMutationVariables
  >(LeaveWorkspaceDocument, options);
}
export type LeaveWorkspaceMutationHookResult = ReturnType<
  typeof useLeaveWorkspaceMutation
>;
export type LeaveWorkspaceMutationResult =
  Apollo.MutationResult<LeaveWorkspaceMutation>;
export type LeaveWorkspaceMutationOptions = Apollo.BaseMutationOptions<
  LeaveWorkspaceMutation,
  LeaveWorkspaceMutationVariables
>;
